// extracted by mini-css-extract-plugin
export var addressFields = "_ov-0";
export var animationContainer = "_ov-1";
export var footer = "_ov-2";
export var lineItems = "_ov-3";
export var modalContent = "_ov-4";
export var orderName = "_ov-5";
export var strong = "_ov-6";
export var warning = "_ov-7";